module.exports = __webpack_public_path__ + "static/media/Butterfly Girl.b13435f4.jpg";